import { __extends } from "tslib";
import React, { createRef } from 'react';
import ReactSwipe from 'react-swipe';
import classnames from 'classnames';
import ErrorBoundary from '../ErrorBoundary';
import s from './SwipeSlider.scss';
var MAX_CHILDREN_COUNT = 5;
var SWIPE_STYLES = {
    container: {
        overflow: 'hidden',
        position: 'relative',
    },
    wrapper: {
        overflow: 'hidden',
        position: 'relative',
    },
    child: {
        float: 'left',
        // we provide all this so ReactSwipe won't put it's own styles on the el
        // and we can override position and left on the child elements to snap
        // overall component height to the height of the active/shown element
        // see also: .active and .child css classes
    },
};
var SwipeSlider = /** @class */ (function (_super) {
    __extends(SwipeSlider, _super);
    function SwipeSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { activeIndex: 0, stopRotation: false, mounted: false };
        _this.reactSwipeEl = createRef();
        _this.goToNextSlideAfterTimeout = function () {
            clearTimeout(_this.timer);
            if (_this.state.stopRotation || !_this.props.goToNextInterval) {
                return;
            }
            _this.timer = setTimeout(function () {
                var items = SwipeSlider.getItems(_this.props.children);
                if (items.length < 2) {
                    return;
                }
                var nextIndex = _this.state.activeIndex + 1;
                if (nextIndex >= items.length) {
                    nextIndex = 0;
                }
                _this.setState({ activeIndex: nextIndex });
                _this.goToNextSlideAfterTimeout();
            }, _this.props.goToNextInterval);
        };
        _this.onSlideChange = function (index) {
            if (!_this.props.goToNextInterval) {
                _this.setState({ activeIndex: index });
            }
        };
        return _this;
    }
    SwipeSlider.prototype.componentDidMount = function () {
        this.setState({ mounted: true });
        if (this.props.goToNextInterval) {
            this.goToNextSlideAfterTimeout();
        }
    };
    SwipeSlider.prototype.componentDidUpdate = function () {
        this.goToNextSlideAfterTimeout();
    };
    SwipeSlider.getDerivedStateFromProps = function (props, state) {
        var items = SwipeSlider.getItems(props.children);
        if (state.activeIndex > items.length - 1) {
            return { activeIndex: items.length - 1 };
        }
        return null;
    };
    SwipeSlider.getItems = function (children) {
        return React.Children.count(children) > MAX_CHILDREN_COUNT
            ? React.Children.toArray(children).slice(0, MAX_CHILDREN_COUNT)
            : React.Children.toArray(children);
    };
    SwipeSlider.prototype.render = function () {
        var _this = this;
        var _a = this.props, indicatorsClassName = _a.indicatorsClassName, children = _a.children;
        var _b = this.state, activeIndex = _b.activeIndex, mounted = _b.mounted;
        var items = SwipeSlider.getItems(children);
        return (React.createElement("div", { className: classnames(s['root'], !mounted && s['not-mounted']) },
            React.createElement(ErrorBoundary, { debugComponent: "SwipeSlider" },
                React.createElement(ReactSwipe, { ref: this.reactSwipeEl, swipeOptions: {
                        startSlide: activeIndex,
                        callback: this.onSlideChange,
                    }, style: SWIPE_STYLES }, items.map(function (child, index) { return (React.createElement("div", { key: child ? child['key'] : index, className: classnames(s['child'], index === activeIndex && s['active']) }, child)); })),
                items.length > 1 && (React.createElement("div", { className: classnames(s['indicators'], indicatorsClassName) }, items.map(function (_, index) { return (React.createElement("div", { key: index, className: classnames(s['indicator'], index === activeIndex && s['active']), onClick: function () {
                        _this.setState({ activeIndex: index, stopRotation: true }, function () {
                            return _this.reactSwipeEl.current &&
                                _this.reactSwipeEl.current.slide(_this.state.activeIndex, 0);
                        });
                    } })); }))))));
    };
    return SwipeSlider;
}(React.Component));
export { SwipeSlider };
export default SwipeSlider;
//# sourceMappingURL=SwipeSlider.js.map